import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container-fuild py-5" style={{ marginTop: "110px" }}>
      <div className="row justify-content-center">
        <div className="col-lg-10">

          {/* Main Card */}
          <div className="card border-0 rounded-4 p-4 p-md-5" style={{ fontSize: "16px", lineHeight: "1.8" }}>
            
            {/* Title */}
            <h1 className="text-center mb-4 fw-bold" style={{ color: "#cc9051" }}>
              Privacy Policy
            </h1>

            <p className="lead" style={{ fontSize: "16px", lineHeight: "1.8" }}>
              <a href="https://tulikaarts.in/" className="text-dark fw-bold">tulikaarts.in</a> values your privacy and is committed to protecting your personal information.
              This Privacy Policy explains how we collect, use, and safeguard your information.
            </p>

            {/* Section */}
            <h4 className="fw-bold mt-4">Information Collection</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Visit our website</li>
              <li className="list-group-item">Contact us via email, phone, or contact form</li>
              <li className="list-group-item">Make a purchase or inquiry</li>
              <li className="list-group-item">Sign up for newsletters or updates</li>
            </ul>

            <h4 className="fw-bold">Types of Information Collected</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">
                <strong>Personal Information:</strong> name, email, phone number, address
              </li>
              <li className="list-group-item">
                <strong>Transactional Information:</strong> payment details, purchase history
              </li>
              <li className="list-group-item">
                <strong>Technical Information:</strong> IP address, browser type, device details
              </li>
              <li className="list-group-item">
                <strong>Analytics Information:</strong> page views, referral sources, usage patterns
              </li>
            </ul>

            <h4 className="fw-bold">Use of Information</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Respond to inquiries and improve customer service</li>
              <li className="list-group-item">Process transactions and payment verification</li>
              <li className="list-group-item">Enhance website functionality and performance</li>
              <li className="list-group-item">Send promotional emails (only with consent)</li>
              <li className="list-group-item">Comply with legal requirements</li>
            </ul>

            <h4 className="fw-bold">Disclosure of Information</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Payment processors & financial partners</li>
              <li className="list-group-item">Shipping & delivery service providers</li>
              <li className="list-group-item">Marketing and analytics partners</li>
              <li className="list-group-item">Law enforcement (only when required)</li>
            </ul>

            <h4 className="fw-bold">Data Security</h4>
            <p>
              We implement strict security measures to safeguard your data, including:
            </p>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Advanced encryption</li>
              <li className="list-group-item">Secure servers</li>
              <li className="list-group-item">Firewalls & monitoring systems</li>
              <li className="list-group-item">Strict access control</li>
            </ul>

            <h4 className="fw-bold">Data Retention</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">As long as required to deliver services</li>
              <li className="list-group-item">As required by legal obligations</li>
              <li className="list-group-item">For internal auditing & record-keeping</li>
            </ul>

            <h4 className="fw-bold">Your Rights</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Request access or update your information</li>
              <li className="list-group-item">Opt-out of marketing communications</li>
              <li className="list-group-item">Request deletion of your data</li>
              <li className="list-group-item">Submit complaints directly to our support team</li>
            </ul>

            <h4 className="fw-bold">Cookies & Tracking</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Enhance website performance</li>
              <li className="list-group-item">Track user behavior for improvements</li>
              <li className="list-group-item">Improve marketing and personalization</li>
            </ul>

            <h4 className="fw-bold">Third-Party Links</h4>
            <p>
              Our website may include external links. We are not responsible for their privacy practices.
            </p>

            <h4 className="fw-bold">Changes to Privacy Policy</h4>
            <p>
              We may update this policy periodically. Continued use of our website implies acceptance.
            </p>

            <h4 className="fw-bold">Contact Us</h4>
            <p>
              For any privacy-related concerns or questions, reach us at:
            </p>
            <p className="mb-0">
              📧 Email: 
              <a href="mailto:tulikartsworks@gmail.com" className="ms-1">
                tulikartsworks@gmail.com
              </a>
            </p>
            <p>
              📞 Phone:
              <a href="tel:+919869261077" className="ms-1">
                +91 9869261077
              </a>
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
